import { render, staticRenderFns } from "./productQuantities.vue?vue&type=template&id=52d94efd"
import script from "./productQuantities.vue?vue&type=script&lang=js"
export * from "./productQuantities.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports